<template>
  <div class="sixteen wide column">

    <prophy-study-card
      v-for="response in visibleResults"
      :key="response.study.studyName"
      :prophy="response"/>

    <fancy-join-group-card
      v-if="visibleResults.length === 0"
      :optionsList="processedRecurringResponseOverall"/>

    <join-group-card
      v-else
      :optionsList="processedRecurringResponseOverall"/>

  </div>
</template>

<script>
import FancyJoinGroupCard from '../survey/recurring/FancyJoinGroupCard'
import JoinGroupCard from '../survey/recurring/JoinGroupCard'
import ProphyStudyCard from '../survey/recurring/ProphyStudyCard'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'GroupTab',
  components: {
    JoinGroupCard,
    ProphyStudyCard,
    FancyJoinGroupCard
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['recurringResponseOverall', 'recurringStudies']),
    ...mapGetters(['processedRecurringResponseOverall']),
    visibleResults: function () {
      return this.processedRecurringResponseOverall.filter(response => response.study.canSeeResults)
    }
  },
  mounted () {
    window.scrollTo(0, 0);
    amplitude.getInstance().logEvent('QB - View Group Tab', { 'View': true });
  },
  activated () {
    // FIXME: This is tied to the ugly emit!
    this.$forceUpdate()
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/views/GroupTab.vue